@if (admin) {
  <span>{{admin.firstName}} {{admin.lastName}}</span>
}
@if (!admin) {
  <span class="label label-default">N/A</span>
}
